export const COMPARISON_PROPS_LIMIT = 14
export const COMPARISON_DEALS_LIMIT = 50
